module.exports = __webpack_public_path__ + "img/hate-toxicity-min.a662d672.jpeg";